import { render, staticRenderFns } from "./PccOrderServiceProperties.vue?vue&type=template&id=40890f6c&scoped=true&"
import script from "./PccOrderServiceProperties.vue?vue&type=script&lang=js&"
export * from "./PccOrderServiceProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40890f6c",
  null
  
)

export default component.exports